// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsProfileLine_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 0H0V24H4V22H2V12.9076C4.87074 14.4287 9.25049 14.3873 13.4773 12.5013C18.7159 10.1637 22.0025 5.75866 21.6239 2H22V14H24V0ZM13.84 2H19.6162C20.1218 4.92927 17.2341 8.63485 12.6623 10.6748C8.41792 12.5688 4.07459 12.4236 2 10.5264V7.33109C3.17669 7.75651 4.54285 8 6 8C10.4183 8 14 5.76142 14 3C14 2.65753 13.9449 2.32311 13.84 2ZM2 2H11.6586C11.8797 2.31278 12 2.64936 12 3C12 4.65685 9.31371 6 6 6C4.46329 6 3.06151 5.71115 2 5.23611V2Z" class="svg-bg"/>
  <path d="M8 20V16H6V24H8L8 20ZM22 20 18 17V19H12V17L8 20 12 23V21H18V23L22 20ZM22 20V24H24V16H22V20Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsProfileLine is a generated icon component.
 */
let IconRmsProfileLine = IconRmsProfileLine_1 = class IconRmsProfileLine extends IconBaseElement {
    render() {
        return html `${IconRmsProfileLine_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsProfileLine.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsProfileLine = IconRmsProfileLine_1 = __decorate([
    customElement('zui-icon-rms-profile-line')
], IconRmsProfileLine);
export { IconRmsProfileLine };
